<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formImport">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 fw-bold">
              <label>Para realizar el proceso de importación de formas de pago de recibos de caja, descargue la guía y
                siga los pasos:</label>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'" [list]="listCompanies"
                [required]="true" [recovery]="true" (onChangeSelect)="getCompany($event)">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                [required]="true" [recovery]="true" (onChangeSelect)="getEnterprise($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="bussinessDocumentsClassId" [labelText]="'Clase'" [list]="listClasses"
                [required]="true" [recovery]="true">
              </app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-end my-2 gap-2">
              <app-custom-button [title]="'Seleccionar Archivo'" [label]="'Seleccionar Archivo'" [severity]="'success'"
                [width]="'10rem'" [icon]="'pi pi-upload'" (onClick)="attach()"
                [disabled]="!permissionUpdatable"></app-custom-button>
              <input id="fileImport" type="file" type="file" (change)="getNameFile($event)" hidden>
              <p class="m-0">{{nameFile}}</p>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-end my-2 gap-2">
              <app-custom-button [title]="'Información.'" [severity]="'secondary'" [icon]="'pi pi-info-circle'"
                (onClick)="openToggle($event)"></app-custom-button>
              <p-popover #information>
                <div>
                  <div class="">
                    <span>
                      <b>Información</b>
                      <br>
                      Este proceso revisa todos los recibos en el archivo de Excel.
                      <br>
                      Si un recibo no existe, se crea automáticamente.
                      <br>
                      Si el recibo ya existe, se actualizan el valor de los abonos y su saldo.
                      <br>
                      <b>Si va a realizar la importacion de facturas:</b>
                      Seleccione clase facturas,
                      <br> Sino seleccione cuentas de cobro.
                    </span>
                  </div>
                </div>
              </p-popover>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-end justify-content-between gap-2 mt-2">
              <app-custom-button [label]="'Descargar Guía Import.'" [severity]="'success'" [width]="'10rem'"
                [disabled]="!permissionUpdatable" (onClick)="downloadGuideImport()"></app-custom-button>
              <app-custom-button [label]="'Importar'" [severity]="'primary'" [disabled]="!permissionUpdatable"
                [variant]="undefined" (onClick)="importWayToPay()" [width]="'5rem'"></app-custom-button>
            </div>
          </div>
          <div class="row">
            <div id="list" *ngIf="visibleTxt">
              <h6>Lista de Errores y Alertas</h6>
              <div id="container-alerts" *ngFor="let wayToPayAlert of wayToPayAlerts">
                <p [ngClass]="errorWayToPay == 1 ? 'message-error' : 'message-alert'">
                  {{wayToPayAlert.message}}
                </p>
              </div>
            </div>
            <div class="row" *ngIf="visibleTxt">
              <div class="d-flex justify-content-end">
                <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'"
                  [width]="'5.5rem'" (onClick)="downloadErrorsTxt()"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>